import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

const ContexBox = ({onModal}) => {
    return (
        <Box className="Moda-from-Software">
            <div className="Moda-from-SoftwareTitle">
                <h1>Software</h1>
            </div>
            <div>
                <Link
                    href="https://mega.nz/#!S3gjjCRK!iIzXm4LRSiO7u-1l9CDMw9-XYGG028PW-bZvJZPuuJY"
                    variant="body2"
                >
                    <h2>Bajar Explorador de Chrome</h2>
                </Link>
            </div>
            <div>
                <Link
                    href="https://mega.nz/#!a7pHXQRR!0QyxeCGKIUPejP_yMSt7IbSeBGv5CW66e1PUhAPWmes"
                    variant="body2"
                >
                    <h2>Bajar el Sistema de Print-Stay</h2>
                </Link>
            </div>
            <div className="Moda-from-Buttom">
                <Button
                    onClick={() => onModal(false)}
                    variant="contained"
                    color="primary"
                >
                    Salir
                </Button>
            </div>
        </Box>
    )
}
 
export default ContexBox;